import { Tc } from "../../../core/_infrastructure/types/common";


export class SolicitudCpeViewModel {

    constructor() {

    }

    public Id: number;
    public Codigo: string;
    public NumeroCertificado: string;
    public Observaciones: string;
    public FechaCreacion: Date;
    public FechaEnvio: Date | null;
    public FechaEmision: Date | null;
    public FechaRechazo: Date | null;
    public IdUsuarioSolicitante: number;
    public IdUsuarioCa: number;
    public IdComunidadAutonoma: number;
    public IdEstado: number = 0;
    public TwOperadorProfesionalCertificadoPrevioEx: TwOperadorProfesionalCpeViewModel = new TwOperadorProfesionalCpeViewModel();
    public TwTcEstadoCertificadoPrevioEx: Tc;
}

export class TwOperadorProfesionalCpeViewModel {
    public IdCertPrevioEx: number;
    public NombreOperador: string;
    public NifOperador: string;
    public LocalidadOperador: string;
    public DireccionOperador: string;
    public IdProvinciaOperador: number;
    public CodigoPostalOperador: string;
}

export class ParametrosNuevaSolicitudCpeViewModel {
    public IdCa: number;
}





